import {Action} from '@ngrx/store';
import {Shift} from '@app/core/models/shift.model';
import {IUserTotalCalcWithDepartment} from '@app/core/interfaces/salary';
import {IPunchEndParams, IPunchStartParams, IPunchStatusReponse} from '@app/core/services/api/dashboard/dashboard.service';
import {User} from '@app/core/models/user.model';
import {IActionsCount, IPunchSettings, IWeather} from '@app/core/store/state/dashboard.state';
import {Group} from '@app/core/models/group.model';

export enum EDashboardActions {
	GetNextShifts = '[Dashboard] Get Next Shifts',
	GetNextShiftsSuccess = '[Dashboard] Get Next Shifts Success',
	GetDashboardActionsCount = '[Dashboard] Get Dashboard Actions Count',
	GetDashboardActionsCountSuccess = '[Dashboard] Get Dashboard Actions Count Success',
	GetDashboardUserSalaryCalculation = '[Dashboard] Get Dashboard User Salary Calculation',
	GetDashboardUserSalaryCalculationSuccess = '[Dashboard] Get Dashboard User Salary Calculation Success',
	GetPunchSettings = '[Dashboard] Get Punch Settings',
	GetPunchSettingsSuccess = '[Dashboard] Get Punch Settings Success',
	PunchIn = '[Dashboard] Punch In',
	PunchInSuccess = '[Dashboard] Punch In Success',
	PunchOut = '[Dashboard] Punch Out',
	PunchOutSuccess = '[Dashboard] Punch Out Success',
	GetPunchStatus = '[Dashboard] Get Punch Status',
	GetPunchStatusSuccess = '[Dashboard] Get Punch Status Success',
	GetAvailableShifts = '[Dashboard] Get Available Shifts',
	GetAvailableShiftsSuccess = '[Dashboard] Get Available Shifts Success',

	OpenPunchPopup = '[Dashboard] Open Punch Popup',

	GetWeatherData = '[Dashboard] Get Weather Data',
	GetWeatherDataSuccess = '[Dashboard] Get Weather Data Success',
}

export class GetNextShifts implements Action {
	public readonly type = EDashboardActions.GetNextShifts;

	constructor(public pageSize: number = 3) {
	}
}

export class GetNextShiftsSuccess implements Action {
	public readonly type = EDashboardActions.GetNextShiftsSuccess;

	constructor(public shifts: Shift[]) {
	}
}

export class GetDashboardActionsCount implements Action {
	public readonly type = EDashboardActions.GetDashboardActionsCount;

	constructor() {
	}
}

export class GetDashboardActionsCountSuccess implements Action {
	public readonly type = EDashboardActions.GetDashboardActionsCountSuccess;

	constructor(public data: IActionsCount) {
	}
}

export class GetDashboardUserSalaryCalculation implements Action {
	public readonly type = EDashboardActions.GetDashboardUserSalaryCalculation;

	constructor(public userId: number, public year: number, public month: number) {
	}
}

export class GetDashboardUserSalaryCalculationSuccess implements Action {
	public readonly type = EDashboardActions.GetDashboardUserSalaryCalculationSuccess;

	constructor(public salaryCalc: IUserTotalCalcWithDepartment) {
	}
}

export class PunchIn implements Action {
	public readonly type = EDashboardActions.PunchIn;

	constructor(public data: IPunchStartParams) {
	}
}

export class PunchInSuccess implements Action {
	public readonly type = EDashboardActions.PunchInSuccess;

	constructor(public data: Shift) {
	}
}

export class PunchOut implements Action {
	public readonly type = EDashboardActions.PunchOut;

	constructor(public data: IPunchEndParams) {
	}
}

export class PunchOutSuccess implements Action {
	public readonly type = EDashboardActions.PunchOutSuccess;

	constructor(public data: Shift) {
	}
}

export class GetPunchStatus implements Action {
	public readonly type = EDashboardActions.GetPunchStatus;

	constructor() {
	}
}

export class GetPunchStatusSuccess implements Action {
	public readonly type = EDashboardActions.GetPunchStatusSuccess;

	constructor(public data: IPunchStatusReponse) {
	}
}

export class OpenPunchPopup implements Action {
	public readonly type = EDashboardActions.OpenPunchPopup;

	constructor(public data: { punchedIn: boolean, shift: Shift, user: User, groups: Group[] }) {
	}
}

export class GetPunchSettings implements Action {
	public readonly type = EDashboardActions.GetPunchSettings;

	constructor() {
	}
}

export class GetPunchSettingsSuccess implements Action {
	public readonly type = EDashboardActions.GetPunchSettingsSuccess;

	constructor(public settings: IPunchSettings) {
	}
}

export class GetAvailableShifts implements Action {
	public readonly type = EDashboardActions.GetAvailableShifts;

	constructor(public pageSize: number = 3) {
	}
}

export class GetAvailableShiftsSuccess implements Action {
	public readonly type = EDashboardActions.GetAvailableShiftsSuccess;

	constructor(public shifts: Shift[]) {
	}
}

export class GetWeatherData implements Action {
	public readonly type = EDashboardActions.GetWeatherData;

	constructor(public postal_code: string, public country_code: string) {
	}
}

export class GetWeatherDataSuccess implements Action {
	public readonly type = EDashboardActions.GetWeatherDataSuccess;

	constructor(public weather: IWeather[]) {
	}
}

export type DashboardActions =
	GetNextShifts |
	GetNextShiftsSuccess |
	GetDashboardActionsCount |
	GetDashboardActionsCountSuccess |
	GetDashboardUserSalaryCalculation |
	GetDashboardUserSalaryCalculationSuccess |
	PunchIn |
	PunchInSuccess |
	PunchOut |
	PunchOutSuccess |
	GetPunchStatus |
	GetPunchStatusSuccess |
	OpenPunchPopup |
	GetPunchSettings |
	GetPunchSettingsSuccess |
	GetAvailableShifts |
	GetAvailableShiftsSuccess |
	GetWeatherData |
	GetWeatherDataSuccess
	;
